export const events = {
  projects: {
    overview: {
      setCardsView: 'projects | overview | set cards view',
      setListView: 'projects | overview | set list view',
      perspectiveTab: 'projects | overview | switch perspective tab'
    },
    sidebar: {
      reports: 'projects | sidebar | go to "Reports" page',
      'for-me': 'projects | sidebar | go to "For me" page',
      views: 'projects | sidebar | go to "Views" page',
      overview: 'projects | sidebar | go to "Overview" page', // add metadata
      perspectives: 'projects | sidebar | go to "Perspectives" page',
      imports: 'projects | sidebar | go to "Imports" page',
      graph: 'projects | sidebar | go to "Graph" page',
      audit: 'projects | sidebar | go to "Audit" page',
      'single-perspective': 'projects | sidebar | go to "Single Perspective" page', // add metadata
      settings: 'projects | sidebar | go to "Settings" page',
      settingsImport: 'projects | sidebar | go to "Settings Import Mappings" page',
      'settings-users': 'projects | sidebar | go to "Settings User Management" page',
      'settings-update_proj': 'projects | sidebar | go to "Settings Update Project" page',
      'settings-delete_proj': 'projects | sidebar | go to "Settings Delete Project" page',
      'settings-blueprint': 'projects | sidebar | go to "Settings Blueprint" page',
      'settings-clear_cache': 'projects | sidebar | go to "Settings Clear Cache" page',
      'settings-integrations': 'projects | sidebar | go to "Settings Integrations" page',
      'settings-integrations_clients': 'projects | sidebar | go to "Settings Integrations Clients" page',
      'settings-project_search': 'projects | sidebar | go to "Settings Project Search" page',
      'settings-data_validation': 'projects | sidebar | go to "Settings Data Validation" page'
    },
    topbar: {
      'history-tooltip': 'projects | top bar | field history button tooltip visible',
      'history-click': 'projects | top bar | field history button click'
    }
  },
  blueprints: {
    overview: {
      setCardsView: 'blueprints | overview | set cards view',
      setListView: 'blueprints | overview | set list view'
    },
    sidebar: {
      release: 'blueprints | sidebar | release blueprint',
      rollback: 'blueprints | sidebar | rollback blueprint',
      create: 'blueprints | sidebar | open create blueprint dialog',
      model: 'blueprints | sidebar | go to "Model" page',
      modules: 'blueprints | sidebar | go to "Modules" page',
      views: 'blueprints | sidebar | go to "Views" page',
      shapes: 'blueprints | sidebar | go to "Shapes" page',
      'project-teams': 'blueprints | sidebar | go to "Project Teams" page',
      perspectives: 'blueprints | sidebar | go to "Perspectives" page',
      reports: 'blueprints | sidebar | go to "Reports" page',
      'settings-name': 'blueprints | sidebar | go to "Settings Name" page',
      'settings-version': 'blueprints | sidebar | go to "Settings Version" page',
      'settings-projects': 'blueprints | sidebar | go to "Settings Projects" page',
      'settings-delete': 'blueprints | sidebar | go to "Settings Delete" page',
      'settings-validations': 'blueprints | sidebar | go to "Settings Validations" page',
      integrations: 'blueprints | sidebar | go to "Integrations" page'
    }
  },
  common: {
    topbar: {
      account: 'top bar | open account menu',
      'app-areas': 'top bar | open app areas menu',
      home: 'top bar | go to home page'
    }
  }
} as const;
